__turbopack_context__.v({
  "className": "o46TZa_className",
  "variable": "o46TZa_variable",
});
